import React, { useContext, useState, useEffect, useRef } from "react";
import { GET_FAVORITE_ITEMS, GET_PRODUCT_BY_ARTICLE } from "../../querys";
import { useMutation, useQuery } from "@apollo/client";
import { typeUserManagment } from "../../services/querysData";
import { AuthUserContext } from "../../context/AuthUser";
import HeartLike from "./Style/HeartLike";
import CardProduct from "./CardProduct";
import { ButtonTL } from "../styled/Button";
import SmallLoader from "../small-loader";
import { Container } from "../styled/ProductsStyled";

import {
  ADD_FAVORITE,
  CREATE_SHIPPING_CART,
  GET_SHIPPING_CART,
  UPDATE_FAVORITE,
  UPDATE_SHIPPING_CART,
} from "../../mutations";
import { toast } from "react-toastify";

const ProductCardType = ({ title, search }) => {
  const { authUser } = useContext(AuthUserContext);
  const rootRef = useRef(null);

  const { data: dataProducts, loading } = useQuery(GET_PRODUCT_BY_ARTICLE, {
    variables: {
      vip: authUser?.typeCustomer && typeUserManagment(authUser.typeCustomer),
      typeSort: "id:DESC",
      article: search,
    },
  });
  const [favoriteItem, setFavoriteItem] = useState({});
  const { data: favoriteList } = useQuery(GET_FAVORITE_ITEMS, {
    variables: {
      id: authUser?.user?.id,
    },
    onCompleted: (data) => {
      setFavoriteItem(data);
    },
  });

  const [addFavorite] = useMutation(ADD_FAVORITE, {
    onCompleted: () => {
      toast.success("Added to favorites successfully");
    },
    onError: () => {
      toast.error("Failed to add favorite, there was a problem on the server");
    },
  });
  const [updateFavorite] = useMutation(UPDATE_FAVORITE, {
    onCompleted: () => {
      // toast.success("Your favorites were updated");
    },
    onError: () => {
      toast.error("Ocurrio un error al actulizar favorito");
    },
  });

  const handleAddFavorite = (item) => {
    const {
      productsid,
      image,
      articlenumber,
      productsummery,
      colornumber,
      regularprice,
    } = item.attributes;

    if (
      favoriteItem.favorites.data[0]?.attributes.favoritelist.find(
        (item) => item.productsid === productsid
      )
    ) {
      const favoritelist =
        favoriteItem.favorites.data[0]?.attributes.favoritelist
          .filter((item) => item.productsid !== productsid)
          .map(({ __typename, ...rest }) => rest);
      updateFavorite({
        variables: {
          id: favoriteItem.favorites.data[0]?.id,
          data: {
            favoritelist,
            users_permissions_user: authUser?.user?.id,
          },
        },
        refetchQueries: ["getFavoriteItem"],
        onCompleted: () => {
          toast.success("Your favorites were updated");
        },
      });
    } else {
      const favoritelist = {
        productsid: productsid,
        image: image,
        articlenumber: articlenumber,
        productsummery: productsummery,
        colornumber: colornumber,
        regularprice: parseFloat(regularprice),
      };

      if (favoriteItem.favorites.data.length === 0) {
        addFavorite({
          variables: {
            data: {
              favoritelist,
              users_permissions_user: authUser?.user?.id,
            },
          },
          refetchQueries: ["getFavoriteItem"],
        });
      } else {
        updateFavorite({
          variables: {
            id: favoriteItem.favorites.data[0]?.id,
            data: {
              favoritelist: [
                ...favoriteItem.favorites.data[0]?.attributes.favoritelist.map(
                  ({ __typename, ...rest }) => rest
                ),
                favoritelist,
              ],
            },
          },
          refetchQueries: ["getFavoriteItem"],
          onCompleted: () => {
            toast.success("Your favorites were updated");
          },
        });
      }
    }
  };

  const [items, setItems] = useState({});
  const { data: cartList } = useQuery(GET_SHIPPING_CART, {
    variables: {
      id: authUser?.user?.id,
    },
    onCompleted: (data) => {
      setItems(data);
    },
  });

  const [addToCart] = useMutation(CREATE_SHIPPING_CART, {
    onCompleted: () => toast.success("Added to cart."),
    onError: () => toast.error("Error adding to cart, please try again"),
  });

  const [updateCart, { updateLoading }] = useMutation(UPDATE_SHIPPING_CART, {
    onCompleted: () => {
      toast.success("Cart updated successfully");
    },
    onError: () => {
      toast.error("There was a problem, the cart could not be updated");
    },
  });

  useEffect(() => {
    setItems(cartList);
  }, [cartList, updateCart, addToCart]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (loading) return;

    const productCheck = dataProducts?.products?.data?.[0];
    if (productCheck) return;

    const el = rootRef.current;
    if (!el) return;

    const slide = el.closest(".slick-slide");
    if (slide) {
      slide.style.display = "none";
    }
  }, [loading, dataProducts]);
  const handleAddToCart = (producto, types) => {
    const {
      productsid,
      colornumber,
      image,
      productsummery,
      regularprice,
      supplierid,
      supplierproductname,
    } = producto.attributes;

    if (
      items &&
      items.cartItems?.data[0]?.attributes?.cartitem?.find(
        (item) => item.productId === productsid
      )
    ) {
      toast.success("The product is already in the cart.");
    } else {
      const cartitem = {
        quantity: "1",
        productId: productsid,
        colortype: colornumber,
        image,
        productSummery: productsummery,
        price: regularprice?.toString(),
        typeofpurchase: types,
        supplierid: supplierid,
        supplierproductname: supplierproductname,
        unitprice: regularprice.toString(),
      };

      if (items.cartItems.data.length === 0) {
        addToCart({
          variables: {
            data: {
              cartitem,
              users_permissions_user: authUser?.user?.id,
            },
          },
          refetchQueries: ["getCartItems", "getCartItem"],
        });
      } else {
        updateCart({
          variables: {
            id: items?.cartItems?.data[0]?.id,
            data: {
              cartitem: [
                ...items.cartItems.data[0]?.attributes.cartitem.map(
                  ({ __typename, ...rest }) => rest
                ),
                cartitem,
              ],
              users_permissions_user: authUser?.user?.id,
            },
          },
          refetchQueries: ["getCartItems", "getCartItem"],
        });
      }
    }
  };

  const product = dataProducts?.products?.data?.[0];

  if (!product) {
    return <div ref={rootRef} />;
  }

  return (
    <div ref={rootRef}>
      <Container className="content-products u-padding-none">
        <div className="row image-slider-container">
          <div className="u-margin-bottom-2 cd-content-button u-position-relative">
            <div className="content-like-heart">
              <button
                className={`btn-heart-favorite ${
                  favoriteList?.favorites?.data[0]?.attributes?.favoritelist.some(
                    (fav) => fav.productsid === product.attributes.productsid
                  ) && "mark-heart-check"
                }`}
                onClick={() => handleAddFavorite(product)}
              >
                <HeartLike />
              </button>
            </div>

            <CardProduct confirmed={0} data={product.attributes} />

            {(authUser.typeCustomer === "Admin" ||
              authUser.typeCustomer === "Special customer") && (
              <ButtonTL
                disabled={updateLoading}
                color="primary"
                weight="light"
                size="small"
                onClick={() => handleAddToCart(product, "swatch")}
                style={{ width: "130px" }}
                className="u-margin-top-2 u-margin-bottom-2"
              >
                {updateLoading ? <SmallLoader /> : "Quick Add"}
              </ButtonTL>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ProductCardType;
